import { Image } from 'app/src/shared/components'
import { Card } from 'primereact/card'

export function HorizontalCard(props: {
  title: string
  subTitle?: string
  description: string
  imageSrc: string
  badge?: {
    badgePrefix: string
    badgeSuffix: string
  }
  tag?: string
  footer?: string
}) {
  const header = (
    <Image
      pt={{ image: { className: 'object-cover lg:w-[210px] lg:h-[190px] w-[260px] h-[240px]' } }}
      aria-hidden
      src={props.imageSrc}
      alt={props.title}
    />
  )

  const divTitle = <div className='max-h-[18px] max-w-[322px] text-[18px] font-semibold leading-[18px]'>{props.title}</div>

  return (
    <div className='card flex flex-col items-center lg:items-start'>
      <Card
        pt={{
          header: () => ({
            className: 'flex items-center lg:flex-row flex-col', //Centro l'img nell'header e Da mobile l'immagine riempie l'header della card
          }),
        }}
        title={divTitle}
        header={header}
        className='min-h-[210px] max-w-[370px] p-[5px] lg:flex lg:h-[240px] lg:max-w-[600px] lg:flex-row'
      >
        <p className='m-0 min-h-[115px] max-w-[322px] py-0 text-[14px] font-normal leading-[21px]'>{props.description}</p>
      </Card>
    </div>
  )
}
